import { UrlHandlingStrategy, UrlTree } from '@angular/router';

/**
 * Tells Angular router and ui-router which URLs each should handle.
 * Angular only activates for routes listed in ANGULAR_OWNED_ROUTES — everything else is left to ui-router.
 * See: https://angular.dev/api/router/UrlHandlingStrategy
 */
// Routes that are handled by new angular
const ANGULAR_OWNED_ROUTES: string[] = [
  ...(FEATURE_BODACDC_2405 ? ['/settings/batching-rules'] : []),
  ...(FEATURE_BODACDC_3966 ? ['/messages'] : []),
];

export class HybridUrlHandlingStrategy implements UrlHandlingStrategy {
  shouldProcessUrl(url: UrlTree): boolean {
    const path = url.toString().split('?')[0];
    return ANGULAR_OWNED_ROUTES.some(route => path.startsWith(route));
  }

  extract(url: UrlTree): UrlTree {
    return url;
  }

  merge(newUrlPart: UrlTree, _rawUrl: UrlTree): UrlTree {
    return newUrlPart;
  }
}
